module.exports = __webpack_public_path__ + "static/media/Trial1-if-correct.1303a513.mp3";